import Index from "views/Index.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import FlashcardsPage from "views/examples/FlashcardsPage";
import QuizPage from "views/examples/QuizPage";
import HomePageView from "views/HomePageView";
import Profile from "views/examples/Profile.js";
import React from 'react';
import CustomGraphBuilder from "./components/CustomGraphBuilder";
import Settings from "views/examples/Settings";
import GeneralStage from "views/examples/GeneralStage";
import GamesPage from "layouts/GamesLayout";
import PasswordReset from "views/PasswordReset.js";
import PremiumPage from "views/PremiumPage.js";
import FeedbackPage from "views/FeedbackPage.js";
import ClassPage from "views/examples/ClassPage.js";


var routes = [
  {
    path: "/index",
    name: "Description",
    icon: "fas fa-book text-primary icon-primary",  // Εφαρμόσαμε την κλάση 'icon-primary' για μπλε χρώμα
    component: <Index />,
    layout: "/admin",
  },
  {
    path: "/icons",
    name: "Examples",
    icon: "fas fa-cogs text-primary icon-primary",  // Εφαρμόσαμε την κλάση 'icon-primary' για μπλε χρώμα
    component: <Icons />,
    layout: "/admin",
  },
  {
    path: "/flashcard",
    name: "Flashcards",
    icon: "fas fa-chalkboard-teacher text-primary icon-primary",  // Εφαρμόσαμε την κλάση 'icon-primary' για μπλε χρώμα
    component: <FlashcardsPage />,
    layout: "/admin",
  },

  {
    path: "/quiz",
    name: "Quiz",
    icon: "fas fa-question-circle text-primary icon-primary",
    component: <QuizPage />,
    layout: "/admin",
  },
  {
    path: "/games",
    name: "Games",
    icon: "fas fa-play-circle text-primary icon-primary",
    component: <GamesPage />,
    layout: "/admin",
  },
  {
    path: "/custom-graph",
    name: "Create",
    icon: "fas fa-pencil-alt text-primary icon-primary",
    component: <CustomGraphBuilder />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    icon: "fas fa-user-lock text-primary icon-primary",  // Εφαρμόσαμε την κλάση 'icon-primary' για μπλε χρώμα
    component: <Login />,
    layout: "/auth",
  },

  {
    path: "/register",
    name: "Register",
    icon: "fas fa-user-plus text-primary icon-primary",  // Εφαρμόσαμε την κλάση 'icon-primary' για μπλε χρώμα
    component: <Register />,
    layout: "/auth",
  },

  {
    path: "/homepage",
    name: "Homepage",
    icon: "fas fa-home text-primary icon-primary",  // Εικονίδιο για σπίτι
    component: <HomePageView />,  // Εδώ χρησιμοποιούμε τη νέα σελίδα
    layout: "/HomePage",
  },

  {
    path: "/MyProfile",
    name: "MyProfile",
    icon: "fas fa-user text-primary icon-primary",  // Εικονίδιο για προφίλ
    component: <Profile />,
    layout: "/admin",
  },

  {
    path: "/Settings",
    name: "Settings",
    icon: "fas fa-cog text-primary icon-primary",  // Εικονίδιο για ρυθμίσεις
    component: <Settings />,
    layout: "/admin",
  },

  {
    path: "/general",
    name: "GeneralStage",
    component: <GeneralStage />,
    layout: "/GeneralStage",
  },

  {
    path: "/classDetails",
    name: "classDetails",
    component: <ClassPage />,
    layout: "/admin",
  },

  {
    path: "/password-reset/:uid/:token",
    name: "Password Reset",
    component: <PasswordReset />,  // Πρόσθεσε τα < /> tags
    layout: "/auth",
  },

  {
    path: "/premium",
    name: "Premium",
    icon: "ni ni-diamond text-warning",
    component: <PremiumPage />,
    layout: "/admin",
  },

  {
    path: "/feedback",
    name: "Feedback",
    component: <FeedbackPage />,
    layout: "/admin",
  }


];

export default routes;
